import Scroll from './Scroll';
import YearBuilder from './YearBuilder';

export default class Sheet {
    constructor(root) {
        this.root = root;

        this.main   = root.main;
        this.config = root.config;
        this.helper = root.helper;
        this.input  = root.input;

        this.maxYears = 2;
        this.years = [];
        this.$sheet = $('<div class="f-calendar__sheet f-calendar_scrollable"></div>');

        const loaderContent = '<svg class="f-calendar__sheet--loader-icon" viewBox="25 25 50 50">' +
            '<circle class="f-calendar__sheet--loader-circle" cx="50" cy="50" r="19"></circle>' +
            '</svg>';

        this.$loaderBefore = $(`<div class="f-calendar__sheet--loader f-calendar__sheet--loader_before">${ loaderContent }</div>`);
        this.$loaderAfter  = $(`<div class="f-calendar__sheet--loader f-calendar__sheet--loader_after">${ loaderContent }</div>`);

        this.scroll = new Scroll(this);
        this.yearBuilder = new YearBuilder(this);
    }

    build() {
        this.$sheet.prepend(this.$loaderBefore);
        this.$sheet.append(this.$loaderAfter);
        this.main.$container.append(this.$sheet);

        // this.resetSpacers();
    }

    clear() {
        const $years = this.$sheet.find('.f-calendar__sheet--year');
        $years.remove();

        this.years = [];
    }

    checkLoaders() {
        const { upperLimit, lowerLimit } = this.config.get();

        const lowerLoaded = this.years[0] === lowerLimit.year;
        const upperLoaded = this.years[this.years.length - 1] === upperLimit.year;

        this.$loaderBefore.toggleClass('f-calendar__sheet--loader-hide', lowerLoaded);
        this.$loaderAfter.toggleClass('f-calendar__sheet--loader-hide', upperLoaded);
    }

    // Проверяет нужно ли добавить год сверху или снизу в зависимости от скролла
    checkNeedAddYear() {
        const { upperLimit, lowerLimit } = this.config.get();

        const result = {
            need: false,
            bounceOut: false,
            directions: []
        };

        // Вычисляем высоту скролла и вычитаем высоту самого блока.
        // Получаем нижний предел, после которого нужно будет достроить год
        const sheet = this.$sheet[0];

        const sheetHeight = this.$sheet.outerHeight();
        const trigger = sheetHeight * 2;

        const scrollHeight = sheet.scrollHeight;
        const scrollTop = Math.round(sheet.scrollTop);
        const scrollBottom = Math.round(scrollHeight - scrollTop - sheetHeight);

        const allowedLowerLimit = this.years[0] > lowerLimit.year;
        const allowedUpperLimit = this.years[this.years.length - 1] < upperLimit.year;

        // Bounce эффект (на айфонах и маках)
        if (scrollTop < 0 || scrollBottom < 0) {
            result.bounceOut = true;
        }
        else {
            // Нужен прошлый год
            if (allowedLowerLimit && scrollTop <= trigger) {
                result.need = true;
                result.directions.push('before');
            }

            // Нужен следующий год
            if (allowedUpperLimit && scrollBottom <= trigger) {
                result.need = true;
                result.directions.push('after');
            }
        }

        return result;
    }

    findDay(selectedDate) {
        const {
            date,
            month,
            year,
            disabled
        } = selectedDate;

        let $day = this.$sheet.find(`[date=${ date }][month=${ month }][year=${ year }]`);

        if (!disabled) {
            $day = $day.not('.f-calendar__sheet--day_disabled');
        }

        return $day.length ? $day : null;
    }

    // Добавляет год в список
    addYear({ year, direction }) {
        const config = this.config.get();
        const years = this.years;

        if (!year && !direction) {
            return false;
        }

        // Не передан год, но передано направление
        if (!year && direction) {
            if (direction === 'before') {
                year = years[0] - 1;
            }
            else {
                year = years[years.length - 1] + 1;
            }
        }

        // Передан год, принудительно вычислаем направление
        if (year) {
            if (!years.length || years[0] > year) {
                direction = 'before';
            }
            else {
                direction = 'after';
            }
        }

        const validYear = (year >= config.lowerLimit.year) && (year <= config.upperLimit.year) && !this.years.includes(year);

        // Год можно добавлять
        if (validYear) {
            const yearStr = this.yearBuilder.build(year);

            let scrollTo = this.scroll.getPosition();
            let removeYears = [];

            // Список пуст или добавляем год вперед списка
            if (direction === 'before') {
                years.unshift(year);

                if (years.length > this.maxYears) {
                    removeYears = years.slice(this.maxYears, years.length);
                }

                // this.$sheet.prepend(yearStr);
                this.$loaderBefore.after(yearStr);
            }
            // Добавляем в конец списка
            else {
                years.push(year);

                if (years.length > this.maxYears) {
                    removeYears = years.slice(0, years.length - this.maxYears);
                }

                // this.$sheet.append(yearStr);
                this.$loaderAfter.before(yearStr);
            }

            // Вычищаем ненужные года
            const removed = removeYears.map(year => this.removeYear(year));

            const $year = this.getYearEl(year);

            // Добавляем в начало списка
            if (direction === 'before') {
                const addedHH = $year.outerHeight();

                scrollTo += addedHH;
            }
            // Добавляем в конец списка
            else {
                const removedHH = removed.reduce((acc, data) => acc + data.height, 0);

                scrollTo -= removedHH;
            }

            // Контролируем отображение лоадеров
            this.checkLoaders();

            // Подписываем dateSelector на скрол месяцев
            if (this.root.dateSelector) {
                this.root.dateSelector.observeYear($year[0]);
            }

            // Нормализуем скролл
            scrollTo = Math.max(1, scrollTo);
            this.scroll.toPosition(scrollTo);
        }
    }

    // Удаляет год из списка
    removeYear(year) {
        const index = this.years.indexOf(year);

        if (index >= 0) {
            this.years.splice(index, 1);
        }

        const $year = this.getYearEl(year);
        const height = $year.outerHeight();

        // Подписываем dateSelector на скрол месяцев
        if (this.root.dateSelector) {
            this.root.dateSelector.unobserveYear($year[0]);
        }

        $year.remove();

        return {
            year,
            index,
            height
        };
    }

    getYearEl(year) {
        return this.$sheet.find(`.f-calendar__sheet--year[year=${ year }]`);
    }

    clearActiveDay() {
        this.$sheet.find('.f-calendar__sheet--day_active').removeClass('f-calendar__sheet--day_active');
        this.$sheet.find('.f-calendar__time-badge').remove();
    }

    setActiveDay() {
        this.clearActiveDay();

        const { dateFormat, type } = this.config.get();
        const inputValue = this.input.getState();

        const parsed = inputValue.parsed;
        const current = this.helper.getCurrentDay();

        if (!parsed) {
            return;
        }

        // Сегодняшний день
        const $currentDay = this.$sheet.find(`.f-calendar__sheet--day[date=${ current.date }][month=${ current.month }][year=${ current.year }]`);

        // Активный (введенный в поле) день
        const $activeDay = this.$sheet
            .find(`.f-calendar__sheet--day[date=${ parsed.date }][month=${ parsed.month }][year=${ parsed.year }]`)
            .not('.f-calendar__sheet--day_disabled')
            .not('.f-calendar__sheet--day_stub');

        $currentDay.addClass('f-calendar__sheet--day_current');
        $activeDay.addClass('f-calendar__sheet--day_active');

        // Добавляем бейдж времени
        if (type !== 'datetime' || typeof parsed.hour !== 'number' || typeof parsed.minute !== 'number') {
            return;
        }

        const time = this.helper.getTimeStr(parsed);
        const ampm = dateFormat.hour12;

        const $badge = $([
            `<div class="f-calendar__time-badge${ ampm ? ' f-calendar__time-badge_ampm' : '' }">`,
            `${ time }`.trim(),
            '</div>'
        ].join(' '));

        $activeDay.append($badge);
    }
}
